// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".descContainer--2jebgs_K {\n  list-style: none;\n  padding-left: 0;\n  margin-bottom: 0;\n}\n\n.iconContainer--1ly_ZKAf {\n  position: relative;\n  top: 0px;\n  color: var(--color-brand);\n}\n\n.iconContainer--1ly_ZKAf:hover {\n  color: var(--color-brand-hover);\n}\n\n.text--3JZgT4vk {\n  margin-right: 5px;\n}\n\n.textEllipsis--2bKbQcTS {\n  display: block;\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"descContainer": "descContainer--2jebgs_K",
	"iconContainer": "iconContainer--1ly_ZKAf",
	"text": "text--3JZgT4vk",
	"textEllipsis": "textEllipsis--2bKbQcTS"
};
export default ___CSS_LOADER_EXPORT___;
